export const DEFAULT_EMPTY_PAGE_SIZE = 10
